import React from 'react';
import PropTypes from 'prop-types';
import 'Modals/modals.scss';

const definitions = [
  ['Access Credentials', `login credentials Customer and Authorized Users shall use to access and use the Service.`],
  [
    'Affiliate',
    `any entity directly or indirectly controlling, controlled by, or under common control with Licensee where "control" means ownership of at least 50% of the equity or beneficial interests of such entity.`,
  ],
  ['Agreement', 'has the meaning set forth in the preamble.'],
  [
    'Authorized Users',
    `Customer's employees, consultants, contractors, and agents described in an Order (a) who are authorized by Customer to access and use the Services under the rights granted to Customer pursuant to this Agreement; and (b) for whom access to the Services has been purchased hereunder.`,
  ],
  [
    'Authorized Assets',
    `Customer's devices, networks, data centers, websites, or other technologies for which the Services are provided.`,
  ],
  ['Availability Requirement', 'has the meaning set forth in Section 4.1.'],
  ['Available', 'has the meaning set forth in Section 4.1.'],
  ['Confidential Information', 'has the meaning set forth in Section 7.1.'],
  ['Customer', 'has the meaning set forth in the Sectrify Security Services Order between Customer and Provider.'],
  [
    'Customer Data',
    `information, data, and other content, in any form or medium, that is collected, downloaded, or otherwise received, directly or indirectly, from Customer or an Authorized User by or through the Services or that incorporates or is derived from the Processing of such information, data, or content by or through the Services. For the avoidance of doubt, Customer Data does not include Resultant Data or any other information reflecting the access or use of the Services by or on behalf of Customer or any Authorized User.`,
  ],
  ['Customer Failure', 'has the meaning set forth in Section 3.1.'],
  ['Customer Indemnitee', 'has the meaning set forth in Section 10.1.'],
  [
    'Customer Systems',
    `the Customer's information technology infrastructure, including computers, software, hardware, databases, electronic systems (including database management systems), and networks, whether operated directly by Customer or through the use of third-party services.`,
  ],
  ['Disclosing Party', 'has the meaning set forth in Section 7.1.'],
  [
    'Documentation',
    `any manuals, instructions, or other documents or materials that the Provider provides or makes available to Customer in any form or medium and which describe the functionality, components, features, or requirements of the Services or Provider Platform, including any aspect of the installation, configuration, integration, operation, use, support, or maintenance thereof whether embedded in the Service or obtained electronically from Provider.`,
  ],
  [
    'Effective Date',
    'has the meaning set forth in the Sectrify Security Services Order between Customer and Provider.',
  ],
  ['Exceptions', 'has the meaning set forth in Section 4.1.'],
  ['Fees', 'has the meaning set forth in Section 6.1.'],
  ['Force Majeure Event', 'has the meaning set forth in Section 13.9.'],
  [
    'Harmful Code',
    `any software, hardware, or other technology, device, or means, including any virus, worm, malware, or other malicious computer code, the purpose or effect of which is to (a) permit unauthorized access to, or to destroy, disrupt, disable, distort, or otherwise harm or impede in any manner any (i) computer, software, firmware, hardware, system, or network; or (ii) any application or function of any of the foregoing or the security, integrity, confidentiality, or use of any data Processed thereby; or (b) prevent Customer or any Authorized User from accessing or using the Services or Provider Systems as intended by this Agreement.`,
  ],
  ['Indemnitee', 'has the meaning set forth in Section 10.3.'],
  ['Indemnitor', 'has the meaning set forth in Section 10.3.'],
  ['Initial Term', 'has the meaning set forth in Section 12.1.'],
  [
    'Intellectual Property Rights',
    `any and all registered and unregistered rights granted, applied for, or otherwise now or hereafter in existence under or related to any patent, copyright, trademark, trade secret, database protection, or other intellectual property rights laws, and all similar or equivalent rights or forms of protection, in any part of the world.`,
  ],
  [
    'Law',
    `any statute, law, ordinance, regulation, rule, code, order, constitution, treaty, common law, judgment, decree, or other requirement of any federal, state, local, or foreign government or political subdivision thereof, or any arbitrator, court, or tribunal of competent jurisdiction.`,
  ],
  [
    'Losses',
    `any and all losses, damages, deficiencies, claims, actions, judgments, settlements, interest, awards, penalties, fines, costs, or expenses of whatever kind, including reasonable attorneys' fees and the costs of enforcing any right to indemnification hereunder and the cost of pursuing any insurance providers.`,
  ],
  ['Order', 'has the meaning set forth in the Sectrify Security Services Order between Customer and Provider.'],
  [
    'Person',
    `an individual, corporation, partnership, joint venture, limited liability entity, governmental authority, unincorporated organization, trust, association, or other entity.`,
  ],
  [
    'Personal Information',
    `information that Customer provides or for which Customer provides access to Provider, or information which Provider creates or obtains on behalf of Customer, in accordance with this Agreement that: (i) directly or indirectly identifies an individual (including, for example, names, signatures, addresses, telephone numbers, email addresses, and other unique identifiers); or (ii) can be used to authenticate an individual (including, without limitation, employee identification numbers, government-issued identification numbers, passwords or PINs, user identification and account access credentials or passwords, financial account numbers, credit report information, student information, biometric, genetic, health, or health insurance data, answers to security questions, and other personal identifiers), in case of both subclauses (i) and (ii). Customer's business contact information is not by itself Personal Information.`,
  ],
  [
    'Proceeding',
    `any action, appeal, audit, charge, claim, complaint, demand, hearing, investigation, litigation, proceeding or suit before any arbitrator, governmental authority or mediator, including bankruptcy and insolvency proceedings.`,
  ],
  [
    'Process',
    `to take any action or perform any operation or set of operations that the Services are capable of taking or performing on any data, information, or other content. "Processing" and "Processed" have correlative meanings.`,
  ],
  ['Provider', 'has the meaning set forth in the Sectrify Security Services Order between Customer and Provider.'],
  [
    'Provider Disabling Device',
    `any software, hardware, or other technology, device, or means (including any back door, time bomb, time out, drop dead device, software routine, or other disabling device) used by Provider or its designee to disable Customer's or any Authorized User's access to or use of the Services automatically with the passage of time or under the positive control of Provider or its designee.`,
  ],
  ['Provider Indemnitee', 'has the meaning set forth in Section 10.2.'],
  [
    'Provider Platform',
    `the Services, Specifications, Documentation, and Provider Systems and any and all other information, data, documents, materials, works, and other content, devices, methods, processes, hardware, software, and other technologies and inventions, including any deliverables, technical or functional descriptions, requirements, plans, patented technologies and methodologies or reports, that are provided or used by Provider or any Subcontractor in connection with the Services or otherwise comprise or relate to the Services or Provider Systems. For the avoidance of doubt, Provider Platform include Resultant Data and any information, data, or other content derived from Provider's monitoring of Customer's access to or use of the Services, but do not include Customer Data.`,
  ],
  [
    'Provider Personnel',
    `all individuals involved in the performance of Services as employees, agents, or independent contractors of Provider or any Subcontractor.`,
  ],
  [
    'Provider Systems',
    `the information technology infrastructure used by or on behalf of Provider in performing the Services, including all computers, software, hardware, databases, electronic systems (including database management systems), and networks, whether operated directly by Provider or through the use of third-party services.`,
  ],
  ['Receiving Party', 'has the meaning set forth in Section 7.1.'],
  ['Reimbursable Expenses', 'has the meaning set forth in Section 6.7.'],
  ['Renewal Term', 'has the meaning set forth in Section 12.2.'],
  [
    'Representatives',
    `with respect to a party, that party's and its Affiliates' employees, officers, directors, consultants, agents, and legal advisors.`,
  ],
  [
    'Resultant Data',
    `data and information related to Customer's use of the Services that is used by Provider in an aggregate and anonymized manner, including to compile statistical and performance information related to the provision and operation of the Services.`,
  ],
  ['Scheduled Downtime', 'has the meaning set forth in Section 4.3.'],
  ['Service Credit', 'has the meaning set forth in Section 4.2.'],
  ['Service Level Failure', 'has the meaning set forth in Section 4.1.'],
  ['Service Period', 'has the meaning set forth in Section 4.1.'],
  ['Services', 'the use of the security-as-a-service platform designated on the Order.'],
  ['Specifications', 'the specifications for the Services set forth in the Order.'],
  ['Subcontractor', 'has the meaning set forth in Section 4.4.'],
  ['Term', 'has the meaning set forth in Section 12.2.'],
  [
    'Third-Party Materials',
    `materials and information, in any form or medium, including any open-source or other software, documents, data, content, specifications, products, equipment, or components of or relating to the Services that are not proprietary to Provider.`,
  ],
];

const useRestrictionItems = [
  'copy, modify, or create copies, derivative works or improvements of the Services or Provider Platform;',
  'rent, lease, lend, sell, sublicense, assign, distribute, publish, transfer, or otherwise make available any Services or Provider Platform to any Person, including on or in connection with the internet or any time-sharing, service bureau, software as a service, cloud, or other technology or service;',
  'reverse engineer, disassemble, decompile, decode, adapt, or otherwise attempt to derive or gain access to the source code of the Services or Provider Platform, in whole or in part;',
  'bypass or breach any security device or protection used by the Services or Provider Platform or access or use the Services or Provider Platform other than by an Authorized User through the use of his or her own then valid Access Credentials;',
  'input, upload, transmit, or otherwise provide to or through the Services or Provider Systems, any information or materials that are unlawful or injurious, or contain, transmit, or activate any Harmful Code;',
  `damage, destroy, disrupt, disable, impair, interfere with, or otherwise impede or harm in any manner the Services, Provider Systems, or Provider's provision of services to any third party, in whole or in part;`,
  `remove, delete, alter, or obscure any trademarks, Specifications, Documentation, warranties, or disclaimers, or any copyright, trademark, patent, or other intellectual property or proprietary rights notices from any Services or Provider Platform, including any copy thereof;`,
  `access or use the Services or Provider Platform in any manner or for any purpose that infringes, misappropriates, or otherwise violates any Intellectual Property Right or other right of any third party (including by any unauthorized access to, misappropriation, use, alteration, destruction, or disclosure of the data of any other Provider customer), or that violates any applicable Law;`,
  `access or use the Services or Provider Platform for purposes of competitive analysis of the Services or Provider Platform, the development, provision, or use of a competing software service or product or any other purpose that is to the Provider's detriment or commercial disadvantage;`,
  'access or use the Services or Provider Platform in, or in association with, the design, construction, maintenance, or operation of any hazardous environments, systems, or applications, any safety response systems or other safety-critical applications, or any other use or application in which the use or failure of the Services could lead to personal injury or severe physical or property damage; or',
  'otherwise access or use the Services or Provider Platform beyond the scope of the authorization granted under this Agreement.',
];

const maliciousDataItems = [
  'are malicious;',
  'effectuate malicious behavior;',
  'impact the availability of digital, computer or other technology systems;',
  'impact the integrity of data; or',
  'are illegal at the source or destination geography jurisdictions.',
];

const serviceLevelCreditConditions = [
  'Provider has no obligation to issue any Service Credit unless: (i) Customer reports the Service Failure to Provider immediately on becoming aware of it; and (ii) requests such Service Credit in writing within ten (10) business days of the Service Level Failure; and',
  'in no event will a Service Level Credit for any Service Period exceed one hundred percent (100%) of the total Fees that are attributable for that Service Period if no Service Level Failure had occurred.',
];

const customerIndemnificationItems = [
  'Customer Data, including any Processing of Customer Data by or on behalf of Provider in accordance with this Agreement;',
  "any other materials or information (including any documents, data, specifications, software, content, or technology) provided by or on behalf of Customer or any Authorized User, including Provider's compliance with any specifications or directions provided by or on behalf of Customer or any Authorized User to the extent prepared without any contribution by Provider;",
  `allegation of facts that, if true, would constitute Customer's breach of any of its representations, warranties, covenants, or obligations under this Agreement; or`,
  'negligence or more culpable act or omission (including recklessness or willful misconduct) by Customer, any Authorized User, or any third party on behalf of Customer or any Authorized User.',
];

const exclusionOfDamagesItems = [
  'loss of production, use, business, revenue, or profit or diminution in value;',
  'impairment, inability to use or loss, interruption, or delay of the Services, other than for the issuance of any applicable Service Credits pursuant to Section 4.2;',
  'loss, damage, corruption, or recovery of data, or breach of data or system security;',
  'cost of replacement goods or services;',
  'loss of goodwill or reputation; or',
  'consequential, incidental, indirect, exemplary, special, enhanced, or punitive damages, regardless of whether such Persons were advised of the possibility of such losses or damages or such losses or damages were otherwise foreseeable, and notwithstanding the failure of any agreed or other remedy of its essential purpose.',
];

const terminationItems = [
  `Provider may terminate this Agreement, effective on written notice to Customer, if Customer fails to pay any amount when due hereunder, and such failure continues more than thirty (30) days after Provider's delivery of written notice thereof;`,
  'either party may terminate this Agreement, effective on written notice to the other party, if the other party materially breaches this Agreement, and such breach: (i) is incapable of cure; or (ii) remains uncured thirty (30) days after the non-breaching party provides the breaching party with written notice of such breach and intent to terminate; and',
  'either party may terminate this Agreement, effective immediately upon written notice to the other party, if the other party: (i) becomes insolvent or is generally unable to pay, or fails to pay, its debts as they become due; (ii) files, or has filed against it, a petition for voluntary or involuntary bankruptcy or otherwise becomes subject, voluntarily or involuntarily, to any proceeding under any domestic or foreign bankruptcy or insolvency Law; (iii) makes or seeks to make a general assignment for the benefit of its creditors; or (iv) applies for or has appointed a receiver, trustee, custodian, or similar agent appointed by order of any court of competent jurisdiction to take charge of or sell any material portion of its property or business.',
];

const effectOfTerminationItems = [
  'all rights, licenses, consents, and authorizations granted by either party to the other hereunder will immediately terminate;',
  `Provider shall immediately cease all use of any Customer Data or Customer's Confidential Information and promptly destroy or delete all documents and tangible materials containing, reflecting, incorporating, or based on Customer Data or Customer's Confidential Information; provided that, for clarity, Provider's obligations under this Section 12.4(b) do not apply to any Resultant Data;`,
  `Customer shall immediately cease all use of any Services or Provider Platform and promptly destroy or delete all documents and tangible materials containing, reflecting, incorporating, or based on any Provider Platform or Provider's Confidential Information;`,
  `notwithstanding anything to the contrary in this Agreement, with respect to information and materials then in its possession or control: (i) the Receiving Party may retain the Disclosing Party's Confidential Information in its then current state and solely to the extent and for so long as required by applicable Law; (ii) Provider may also retain Customer Data in its backups, archives, and disaster recovery systems until such Customer Data is deleted in the ordinary course; and (iii) all information and materials described in this Section 12.4(d) will remain subject to all confidentiality, security, and other applicable requirements of this Agreement following termination; and`,
  'Provider may disable all Customer and Authorized User access to the Provider Platform;',
];

const interpretationItems = [
  'the words "include," "includes," and "including" are deemed to be followed by the words "without limitation";',
  'the word "or" is not exclusive;',
  'the words "herein," "hereof," "hereby," "hereto," and "hereunder" refer to this Agreement as a whole;',
  'words denoting the singular have a comparable meaning when used in the plural, and vice-versa; and',
  'words denoting any gender include all genders.',
];

const referenceItems = [
  'to sections, exhibits, schedules, attachments, and appendices mean the sections of, and exhibits, schedules, attachments, and appendices attached to, this Agreement;',
  'to an agreement, instrument, or other document means such agreement, instrument, or other document as amended, supplemented, and modified from time to time to the extent permitted by the provisions thereof; and',
  'to a statute means such statute as amended from time to time and includes any successor legislation thereto and any regulations promulgated thereunder.',
];

const forceMajeureItems = [
  'acts of God;',
  'flood, fire, or earthquake;',
  'war, invasion, terrorist acts, or riot;',
  'government order, law, or actions;',
  'embargoes or blockades; and',
  'shortage of adequate power or transportation facilities.',
];

const DashList = ({ items }) => (
  <ul className="dashed">
    {items.map((item, index) => (
      <li key={index}>{item}</li>
    ))}
  </ul>
);
DashList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.string).isRequired,
};

const Section = ({ title, children }) => (
  <div className="section">
    <h4 className="header">{title}</h4>
    <div className="content">{children}</div>
  </div>
);
Section.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

const Menu = ({ title, children, black = false }) => (
  <div className="menu">
    {title ? <h5 className={`header${black ? ' black' : ''}`}>{title}</h5> : null}
    <div className="content">{children}</div>
  </div>
);
Menu.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node.isRequired,
  black: PropTypes.bool,
};
Menu.defaultProps = {
  title: undefined,
  black: false,
};

const Topic = ({ title, children }) => (
  <div className="topic">
    {title ? <h6 className="header">{title}</h6> : null}
    <div className="content">{children}</div>
  </div>
);
Topic.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node.isRequired,
};
Topic.defaultProps = {
  title: undefined,
};

const formatDefinition = (description) =>
  description.startsWith('has the meaning') ? description : `means ${description}`;

export default function TermsAndConditions() {
  return (
    <div className="modal__content privacy-policy">
      <div className="main header">
        <h4>SECTRIFY</h4>
        <p className="head">Terms and Conditions</p>
      </div>
      <div className="encloser">
        <div className="main content">
          <div className="basic">
            <p>
              These Terms and Conditions, together with the Order executed between the Customer and Provider (as such
              terms are defined in the Order) are collectively the &quot;Agreement&quot; and are effective as of the
              Effective Date.
            </p>
            <p>
              Defined terms used and not defined in these Terms and Conditions have the meaning given such terms in the
              Order, and defined terms used and not defined in the Order have the meaning given such terms in these
              Terms and Conditions.
            </p>
            <p>
              In consideration of the mutual covenants, terms, and conditions set forth herein, and for other good and
              valuable consideration, the receipt and sufficiency of which are hereby acknowledged, the parties agree as
              follows:
            </p>
          </div>

          <Section title="Services">
            <Menu title="Provision of Services">
              <Topic>
                <p>During the Term, Provider shall provide the Services to Customer as provided in this Agreement.</p>
              </Topic>
            </Menu>
            <Menu title="Access and Use">
              <Topic>
                <p>
                  Subject to and conditioned on Customer&apos;s and its Authorized Users&apos; compliance with the terms
                  and conditions of this Agreement, Provider hereby grants Customer a non-exclusive, non-transferable
                  (except in compliance with Section 13.8) right to access and use the Services during the Term, solely
                  for use by Authorized Users in accordance with the terms and conditions herein.
                </p>
                <p>
                  Such use is limited to Customer&apos;s use. To the extent applicable, Provider shall provide Customer
                  access to Provider&apos;s contracted systems and services as of the Effective Date.
                </p>
                <p>
                  Customer shall not exceed the agreed upon service utilization thresholds, including but not limited
                  to, bandwidth, segments, users, or devices, except as expressly agreed to in writing by the parties
                  and subject to any appropriate adjustment of the Fees payable hereunder.
                </p>
                <p>
                  Provider hereby grants to Customer a non-exclusive, non-sublicensable, non-transferable (except in
                  compliance with Section 13.8) license to use the Documentation during the Term solely for
                  Customer&apos;s business purposes in connection with its use of the Services.
                </p>
                <p>
                  Provider represents, warrants, and covenants to Customer that Provider will perform the Services using
                  personnel of required skill, experience, and qualifications and in a professional and workmanlike
                  manner in accordance with generally recognized industry standards for similar services and will devote
                  adequate resources to meet its obligations under this Agreement.
                </p>
              </Topic>
            </Menu>
            <Menu title="Service and System Control">
              <Topic>
                <p>Except as otherwise expressly provided in this Agreement, as between the parties:</p>
                <DashList
                  items={[
                    'Provider has and will retain sole control over and responsibility for the operation, maintenance, and management of the Provider Platform; and',
                    `Customer has and will retain sole control over and responsibility for the provisioning of connectivity to the Provider Platform and systems and for the operation, maintenance, and management of, and all access to and use of, the Customer Systems, and sole responsibility for all access to and use of the Provider Platform by any Person, device, system or application by or through the Customer Systems or any other means controlled by Customer or any Authorized User, device, system, or application, including any: (i) information, instructions, or materials provided by any of them to the Services or Provider; (ii) results obtained from any use of the Services or Provider Platform; and (iii) conclusions, decisions, or actions based on such use.`,
                  ]}
                />
              </Topic>
            </Menu>
            <Menu title="Reservation of Rights">
              <Topic>
                <p>
                  Nothing in this Agreement grants any right, title, or interest in or to (including any license under)
                  any Intellectual Property Rights in or relating to, the Services, Provider Platform, or Third-Party
                  Materials, whether expressly, by implication, estoppel, or otherwise.
                </p>
                <p>
                  All right, title, and interest in and to the Services, the Provider Platform, and the Third-Party
                  Materials are and will remain with Provider and the respective rights holders in the Third-Party
                  Materials.
                </p>
              </Topic>
            </Menu>
            <Menu title="Service Management">
              <Topic>
                <p>
                  Each party shall, throughout the Term, maintain within its organization a billing manager to serve as
                  such party&apos;s primary point of contact for day-to-day communications, consultation, and
                  decision-making regarding administrative, Fee, legal, and business aspects of this Agreement.
                </p>
                <p>
                  Each billing manager shall be responsible for providing all day-to-day consents and approvals on
                  behalf of such party under this Agreement.
                </p>
                <p>
                  Each party shall, throughout the Term, maintain within its organization a service manager to serve as
                  such party&apos;s primary point of contact for technical and logistical support, implementation,
                  software and hardware problem solving, and other issues related to the functionality of the Provider
                  Platform and the Customer Systems.
                </p>
                <p>
                  Each party shall ensure its service manager and billing manager has the requisite organizational
                  authority, skill, experience, and other qualifications to perform in such capacity.
                </p>
                <p>
                  The parties&apos; initial service managers and billing managers are identified in the Order. If either
                  party&apos;s service manager ceases to be employed by such party or such party otherwise wishes to
                  replace its service manager, such party shall promptly name a new service manager by written notice to
                  the other party.
                </p>
              </Topic>
            </Menu>
            <Menu title="Suspension or Termination of Services">
              <Topic>
                <p>
                  Provider may, directly or indirectly, suspend, terminate, or otherwise deny Customer&apos;s, any
                  Authorized User&apos;s, or any other Person&apos;s access to or use of all or any part of the Services
                  or Provider Platform, without incurring any resulting obligation or liability, if: (a) Provider
                  receives a government order, subpoena requires Provider to do so; or (b) Provider believes, in its
                  good faith and reasonable discretion, that: (i) Customer or any Authorized User has failed to comply
                  with any material term of this Agreement, or accessed or used the Services in a material manner beyond
                  the scope of the rights granted or for a purpose not authorized under this Agreement or in any manner
                  that does not comply with any instruction or requirement of the Specifications; (ii) Customer or any
                  Authorized User is, has been, or is likely to be involved in any fraudulent, or unlawful activities;
                  or (iii) this Agreement expires or is terminated.
                </p>
                <p>
                  This Section 1.6 does not limit any of Provider&apos;s other rights or remedies, whether at law, in
                  equity, or under this Agreement.
                </p>
              </Topic>
            </Menu>
            <Menu title="Trial Services">
              <Topic>
                <p>
                  If Customer is using a free trial, proof of concept version of the Services, a beta version of the
                  Services, or using the Services on any other free-of-charge basis as specified in an Order including
                  any related support services (collectively, &quot;Trial Services&quot;), Provider makes such Trial
                  Services available to Customer until the earlier of (i) the end of the free trial or proof of concept
                  period or beta testing period as communicated by Provider, (ii) the start date of any purchased
                  version of such Services, or (iii) termination of Services by Provider with or without notice from
                  Provider.
                </p>
                <p>
                  Customer is authorized to use Trial Services only for evaluation and not for any business or
                  productive purposes. Any data Customer enters into the Trial Services and any configurations made to
                  the Trial Services by or for Customer during the term of such Trial Services will be permanently lost.
                </p>
                <p>
                  The rights, representations, and warranties described in Section 4 shall have no effect on, or
                  otherwise apply to, any Trial Services.
                </p>
              </Topic>
            </Menu>
          </Section>

          <Section title="Use Restrictions and Service Usage">
            <Menu title="Use Restrictions">
              <Topic>
                <p>
                  Customer shall not, and shall not permit any other Person to, access or use the Services or Provider
                  Platform except as expressly permitted by this Agreement and, in the case of Third-Party Materials,
                  the applicable third-party license agreement.
                </p>
                <p>
                  For purposes of clarity and without limiting the generality of the foregoing, Customer shall not,
                  except as this Agreement expressly permits:
                </p>
                <DashList items={useRestrictionItems} />
                <p>
                  <span className="head">Knowingly communicate or transfer data or technology that:</span>
                </p>
                <DashList items={maliciousDataItems} />
              </Topic>
            </Menu>
          </Section>

          <Section title="Customer Obligations">
            <Menu title="Customer Systems and Cooperation">
              <Topic>
                <p>
                  Customer shall at all times during the Term: (a) set up, maintain, and operate in good repair and in
                  accordance with industry standards the Specifications all Customer Systems on or through which the
                  Services are accessed or used; (b) provide Provider Personnel with such access to Customer&apos;s
                  premises and Customer Systems as is necessary for Provider to perform the Services in accordance with
                  the Availability Requirement and Specifications; and (c) provide all cooperation and assistance as
                  Provider may reasonably request to enable Provider to exercise its rights and perform its obligations
                  under and in connection with this Agreement.
                </p>
                <p>
                  Provider is not responsible or liable for any delay or failure of performance caused in whole or in
                  part by Customer&apos;s delay in performing, or failure to perform, any of its obligations under this
                  Agreement (each, a &quot;Customer Failure&quot;).
                </p>
              </Topic>
            </Menu>
            <Menu title="Corrective Action and Notice">
              <Topic>
                <p>
                  If Customer becomes aware of any actual or threatened activity prohibited by Section 2.1, Customer
                  shall, and shall cause its Authorized Users to, immediately: (a) take all reasonable and lawful
                  measures within their respective control that are necessary to stop the activity or threatened
                  activity and to mitigate its effects (including, where applicable, by discontinuing and preventing any
                  unauthorized access to the Services and Provider Platform and permanently erasing from their systems
                  and destroying any data to which any of them have gained unauthorized access); and (b) notify Provider
                  in writing of any such actual or threatened activity.
                </p>
              </Topic>
            </Menu>
            <Menu title="Non-Solicitation">
              <Topic>
                <p>
                  During the Term and for two (2) years after, Customer shall not, and shall not assist any other Person
                  to, directly or indirectly, recruit or solicit for employment or engagement as an independent
                  contractor any Person then or within the prior twelve (12) months employed or engaged by Provider or
                  any Subcontractor.
                </p>
                <p>
                  In the event of a violation of this Section 3.3 Provider will be entitled to liquidated damages equal
                  to the compensation paid by Provider to the applicable employee or contractor during the prior twelve
                  (12) months.
                </p>
              </Topic>
            </Menu>
          </Section>

          <Section title="Service Levels and Credits">
            <Menu title="Service Levels">
              <Topic>
                <p>
                  Subject to the terms and conditions of this Agreement, Provider will use commercially reasonable
                  efforts to make the Services Available at least ninety-nine and nine-tenths percent (99.9%) of the
                  time as measured over the course of each calendar month during the Term (each such calendar month, a
                  &quot;Service Period&quot;), excluding unavailability as a result of any of the Exceptions described
                  below in this Section 4.1 (the &quot;Availability Requirement&quot;).
                </p>
                <p>
                  &quot;Service Level Failure&quot; means a material failure of the Services to meet the Availability
                  Requirement. &quot;Available&quot; means the Services are available for access and use by Customer and
                  its Authorized Users over the Internet and operating in material accordance with the Specifications.
                </p>
                <p>
                  For purposes of calculating the Availability Requirement, the following are &quot;Exceptions&quot; to
                  the Availability Requirement:
                </p>
                <DashList
                  items={[
                    'act or omission by Customer or any Authorized User;',
                    `access to or use of the Services by Customer or any Authorized User, or using Customer's or an Authorized User's Access Credentials, that does not strictly comply with this Agreement and the Specifications;`,
                    'Customer Failure;',
                    `Customer's or its Authorized User's Internet connectivity;`,
                    'Force Majeure Event;',
                    'failure, interruption, outage, or other problem with any software, hardware, system, network, facility, or other matter not supplied by Provider pursuant to this Agreement;',
                    'Scheduled Downtime; or',
                    'disabling, suspension, or termination of the Services pursuant to 1.6.',
                  ]}
                />
              </Topic>
            </Menu>
            <Menu title="Service Level Failures and Remedies">
              <Topic>
                <p>
                  In the event of a Service Level Failure, Provider shall issue a credit to Customer in the amount of
                  (i) twenty-five percent (25%) of the Fees attributable to the relevant Service Period for Service
                  Level Failure lasting for under one (1) hour; (ii) fifty percent (50%) of the Fees attributable to the
                  relevant Service Period for Service Level Failure lasting for between one to two (1-2) hours; and
                  (iii) one hundred percent (100%) of the Fees attributable to the relevant Service Period for Service
                  Level Failure lasting for over two (2) hours for the Services due for the Service Period the Service
                  Level Failure occurred (each a &quot;Service Credit&quot;), subject to the following:
                </p>
                <DashList items={serviceLevelCreditConditions} />
                <p>
                  Any Service Credit payable to Customer under this Agreement will be issued to Customer as a credit
                  against the next payment of Fees, or if no further Fees are payable, as a refund payable within thirty
                  (30) days.
                </p>
                <p>
                  This Section 4.2 sets forth Provider&apos;s sole obligation and liability and Customer&apos;s sole
                  remedy for any Service Level Failure. If the Fees are payable for a period of time including more than
                  one (1) Service Period, the Fees attributable to a Service Period shall equal the total Fees for the
                  period of time that includes the relevant Service Period divided by the number of Service Periods in
                  such period of time.
                </p>
              </Topic>
            </Menu>
            <Menu title="Scheduled Downtime">
              <Topic>
                <p>
                  Provider will use commercially reasonable efforts to: (a) schedule downtime for routine maintenance of
                  the Services between the hours of eight p.m. (20:00) and six a.m. (06:00) of the Provider service
                  delivery location&apos;s local time zone; and (b) give Customer at least twenty-four (24) hours prior
                  notice of all scheduled outages of the Services (&quot;Scheduled Downtime&quot;).
                </p>
                <p>
                  From time-to-time circumstances may arise requiring immediate maintenance from Provider
                  (&quot;Emergency Maintenance&quot;). Such Emergency Maintenance shall relieve Provider of the notice
                  requirement set forth in Section 4.3 and require no notice.
                </p>
              </Topic>
            </Menu>
            <Menu>
              <Topic>
                <p>
                  Provider reserves the right, in its sole discretion, to make any changes to the Services and Provider
                  Platform that it deems necessary or useful to: (a) maintain or enhance the quality or delivery of
                  Provider&apos;s services to its customers; (b) the Services&apos; cost efficiency or performance; or
                  (c) to comply with applicable Law.
                </p>
                <p>
                  Provider may from time to time in its discretion engage third parties to perform Services (each, a
                  &quot;Subcontractor&quot;).
                </p>
              </Topic>
            </Menu>
          </Section>

          <Section title="Security">
            <Menu title="Customer Control and Responsibility">
              <Topic>
                <p>
                  Customer has and will retain sole responsibility for: (a) all Customer Data, including its content and
                  use; (b) all information, instructions, and materials provided by or on behalf of Customer or any
                  Authorized User in connection with the Services; (c) Customer&apos;s information technology
                  infrastructure, including computers, software, databases, electronic systems (including database
                  management systems), and networks, whether operated directly by Customer or through the use of
                  third-party services (&quot;Customer Systems&quot;); (d) the security and use of Customer&apos;s and
                  its Authorized Users&apos; Access Credentials; and (e) all access to and use of the Services and
                  Provider Platform directly or indirectly by or through the Customer Systems or its or its Authorized
                  Users&apos; Access Credentials, with or without Customer&apos;s knowledge or consent, including all
                  results obtained from, and all conclusions, decisions, and actions based on, such access or use.
                </p>
                <p>
                  Customer represents, warrants, and covenants to Provider that Customer owns or otherwise has and will
                  have the necessary rights and consents in and relating to the Customer Data so that, as received by
                  Provider and Processed in accordance with this Agreement, they do not and will not infringe,
                  misappropriate, or otherwise violate any Intellectual Property Rights, or any privacy or other rights
                  of any third party or violate any applicable Law.
                </p>
              </Topic>
            </Menu>
          </Section>

          <Section title="Fees and Payment">
            <Menu title="Fees">
              <Topic>
                <p>
                  Customer shall pay Provider the fees set forth in Exhibit A (&quot;Fees&quot;) in accordance with this
                  Section 6.
                </p>
              </Topic>
            </Menu>
            <Menu title="Taxes">
              <Topic>
                <p>
                  All Fees and other amounts payable by Customer under this Agreement are exclusive of taxes and similar
                  assessments.
                </p>
                <p>
                  Without limiting the foregoing, Customer is responsible for all sales, use, and excise taxes, and any
                  other similar taxes, duties, and charges of any kind imposed by any federal, state, or local
                  governmental or regulatory authority on any amounts payable by Customer hereunder, other than any
                  taxes imposed on Provider&apos;s income.
                </p>
              </Topic>
            </Menu>
            <Menu title="Payment">
              <Topic>
                <p>
                  Customer shall pay all Fees and Reimbursable Expenses within 30 (thirty) days after the date of the
                  invoice therefor. Customer shall make all payments hereunder in United States dollars.
                </p>
                <p>
                  Customer shall make payments to the address or account specified in Exhibit A or such other address or
                  account as Provider may specify in writing from time to time.
                </p>
              </Topic>
            </Menu>
            <Menu title="Late Payment">
              <Topic>
                <p>
                  If Customer fails to make any payment when due then, in addition to all other remedies that may be
                  available:
                </p>
                <DashList
                  items={[
                    'Provider may charge interest on the past due amount at the rate of 1.5% per month or, if lower, the highest rate permitted under applicable Law;',
                    `Customer shall reimburse Provider for all costs incurred by Provider in collecting any late payments or interest, including attorneys' fees, court costs, and collection agency fees; and`,
                    'if such failure continues for ten (10) days following written notice thereof, Provider may suspend performance of the Services until all past due amounts and interest thereon have been paid, without incurring any obligation or liability to Customer or any other Person by reason of such suspension.',
                  ]}
                />
              </Topic>
            </Menu>
            <Menu title="No Deductions or Setoffs">
              <Topic>
                <p>
                  All amounts payable to Provider under this Agreement shall be paid by Customer to Provider in full
                  without any setoff, recoupment, counterclaim, deduction, debit, or withholding for any reason (other
                  than Service Credits issued pursuant to 4.2).
                </p>
              </Topic>
            </Menu>
            <Menu title="Fee Increases">
              <Topic>
                <p>
                  Provider may increase Fees for any Renewal Term by providing written notice to Customer at least
                  thirty (30) calendar days prior to the commencement of such Renewal Term, and Exhibit A will be deemed
                  amended accordingly.
                </p>
              </Topic>
            </Menu>
            <Menu title="Reimbursable Expenses">
              <Topic>
                <p>
                  Customer shall reimburse Provider for out-of-pocket expenses directly attributable to the delivery of
                  Services to Customer incurred by Provider in connection with performing the Services
                  (&quot;Reimbursable Expenses&quot;).
                </p>
                <p>
                  Any Reimbursable Expenses in excess of five percent (5%) of the Fees attributable to the calendar year
                  in which such expenses are incurred must be approved by Customer.
                </p>
              </Topic>
            </Menu>
          </Section>

          <Section title="Confidentiality">
            <Menu title="Confidential Information">
              <Topic>
                <p>
                  In connection with this Agreement each party (as the &quot;Disclosing Party&quot;) may disclose or
                  make available Confidential Information to the other party (as the &quot;Receiving Party&quot;).
                </p>
                <p>
                  Subject to Section 7.2, &quot;Confidential Information&quot; means information in any form or medium
                  (whether oral, written, electronic, or other) that the Disclosing Party considers confidential or
                  proprietary, including information consisting of or relating to the Disclosing Party&apos;s
                  technology, trade secrets, know-how, business operations, plans, strategies, customers, and pricing,
                  and information with respect to which the Disclosing Party has contractual or other confidentiality
                  obligations, in each case whether or not marked, designated, or otherwise identified as
                  &quot;confidential&quot;.
                </p>
                <p>
                  Without limiting the foregoing: all Provider Platform are the Confidential Information of Provider and
                  the financial terms and existence of this Agreement are the Confidential Information of Provider.
                </p>
              </Topic>
            </Menu>
            <Menu title="Exclusions">
              <Topic>
                <p>
                  Confidential Information does not include information that the Receiving Party can demonstrate by
                  written or other documentary records:
                </p>
                <DashList
                  items={[
                    `was rightfully known to the Receiving Party without restriction on use or disclosure prior to such information's being disclosed or made available to the Receiving Party in connection with this Agreement;`,
                    `was or becomes generally known by the public other than by the Receiving Party's or any of its Representatives' noncompliance with this Agreement;`,
                    `was or is received by the Receiving Party on a non-confidential basis from a third party that, to the Receiving Party's knowledge, was not or is not, at the time of such receipt, under any obligation to maintain its confidentiality; or`,
                    `the Receiving Party can demonstrate by written or other documentary records was or is independently developed by the Receiving Party without reference to or use of any Confidential Information.`,
                  ]}
                />
              </Topic>
            </Menu>
            <Menu title="Protection of Confidential Information">
              <Topic>
                <p>
                  As a condition to being provided with any disclosure of or access to Confidential Information, the
                  Receiving Party shall for the duration of the Term of this Agreement and for two (2) years following
                  the termination or expiration of this Agreement:
                </p>
                <DashList
                  items={[
                    'not access or use Confidential Information other than as necessary to exercise its rights or perform its obligations under and in accordance with this Agreement;',
                    "except as may be permitted by and subject to its compliance with Section 7.4, not disclose or permit access to Confidential Information other than to its Representatives who: (i) need to know such Confidential Information for purposes of the Receiving Party's exercise of its rights or performance of its obligations under and in accordance with this Agreement; (ii) have been informed of the confidential nature of the Confidential Information and the Receiving Party's obligations under this Section 7.3; and (iii) are bound by written confidentiality and restricted use obligations at least as protective of the Confidential Information as the terms set forth in this Section 7;",
                    'safeguard the Confidential Information from unauthorized use, access, or disclosure using at least the degree of care it uses to protect its own information and in no event less than a reasonable degree of care in accordance with industry standards;',
                    'promptly notify the Disclosing Party of any unauthorized use or disclosure of Confidential Information and take all reasonable steps/use its best efforts/cooperate with Disclosing Party to prevent further unauthorized use or disclosure; and',
                    `ensure its Representatives' compliance with, and be responsible and liable for any of its Representatives' non-compliance with, the terms of this Section 7.`,
                  ]}
                />
                <p>
                  Notwithstanding any other provisions of this Agreement, the Receiving Party&apos;s obligations under
                  this Section 7 with respect to any Confidential Information that constitutes a trade secret under any
                  applicable Law will continue until such time, if ever, as such Confidential Information ceases to
                  qualify for trade secret protection under one or more such applicable Laws other than as a result of
                  any act or omission of the Receiving Party or any of its Representatives.
                </p>
              </Topic>
            </Menu>
            <Menu title="Compelled Disclosures">
              <Topic>
                <p>
                  If the Receiving Party or any of its Representatives is compelled by applicable Law, to disclose any
                  Confidential Information then, to the extent permitted by applicable Law, the Receiving Party shall:
                  (a) promptly, and prior to such disclosure, notify the Disclosing Party in writing of such requirement
                  so that the Disclosing Party can seek a protective order or other remedy or waive its rights under
                  Section 7.3; and (b) provide reasonable assistance to the Disclosing Party, at the Disclosing
                  Party&apos;s sole cost and expense, in opposing such disclosure or seeking a protective order or other
                  limitations on disclosure.
                </p>
                <p>
                  If the Disclosing Party waives compliance or, after providing the notice and assistance required under
                  this Section 7.4, the Receiving Party remains required by Law to disclose any Confidential
                  Information, the Receiving Party shall disclose only that portion of the Confidential Information
                  that, on the advice of the Receiving Party&apos;s legal counsel, the Receiving Party is legally
                  required to disclose and, on the Disclosing Party&apos;s request, shall use commercially reasonable
                  efforts to obtain assurances from the applicable court or other presiding authority that such
                  Confidential Information will be afforded confidential treatment.
                </p>
              </Topic>
            </Menu>
          </Section>

          <Section title="Intellectual Property Rights">
            <Menu title="Provider Platform">
              <Topic>
                <p>
                  All right, title, and interest in and to the Provider Platform, including all Intellectual Property
                  Rights therein, are and will remain with Provider and, with respect to Third-Party Materials, the
                  applicable third-party providers own all right, title, and interest, including all Intellectual
                  Property Rights, in and to the Third-Party Materials.
                </p>
                <p>
                  Customer has no right, license, or authorization with respect to any of the Provider Platform except
                  as expressly set forth in Section 1 or the applicable third-party license, in each case subject to
                  Section 2.1. All other rights in and to the Provider Platform are expressly reserved by Provider.
                </p>
                <p>
                  In furtherance of the foregoing, Customer hereby unconditionally and irrevocably grants to Provider an
                  assignment of all right, title, and interest in and to the Resultant Data, including all Intellectual
                  Property Rights relating thereto.
                </p>
              </Topic>
            </Menu>
            <Menu title="Customer Data">
              <Topic>
                <p>
                  All right, title, and interest in and to the Customer Data, including all Intellectual Property Rights
                  therein, are and will remain with Customer.
                </p>
                <p>
                  As between Customer and Provider, Customer is and will remain the sole and exclusive owner of all
                  right, title, and interest in and to all Customer Data, including all Intellectual Property Rights
                  relating thereto.
                </p>
              </Topic>
            </Menu>
            <Menu title="Data Backup">
              <Topic>
                <p>
                  The Services do not include, nor does the Service replace, the need for Customer to maintain regular
                  data backups or redundant data archives.
                </p>
                <p>
                  <span className="head">
                    PROVIDER HAS NO OBLIGATION OR LIABILITY FOR ANY LOSS, ALTERATION, DESTRUCTION, DAMAGE, CORRUPTION,
                    OR RECOVERY OF CUSTOMER DATA.
                  </span>
                </p>
              </Topic>
            </Menu>
            <Menu title="Service Suggestions">
              <Topic>
                <p>
                  To the extent that Customer provides Provider with ideas or suggestions for improvements or changes to
                  the Service which constitute Intellectual Property Rights under applicable law
                  (&quot;Suggestions&quot;), Customer hereby assigns to Provider ownership of such Suggestions and
                  Provider will have sole discretion as to whether and how to implement such Suggestions into the
                  Service.
                </p>
              </Topic>
            </Menu>
          </Section>

          <Section title="Definitions">
            <Menu>
              {definitions.map(([term, description]) => (
                <Topic key={term} title={term}>
                  <p>
                    <span className="head">{term}</span> {formatDefinition(description)}
                  </p>
                </Topic>
              ))}
            </Menu>
          </Section>

          <Section title="Indemnification">
            <Menu title="Provider Indemnification">
              <Topic>
                <p>
                  Provider shall indemnify, defend, and hold harmless Customer and its Affiliates and each of its and
                  their respective officers, directors, employees, agents, permitted successors, and permitted assigns
                  (each, a &quot;Customer Indemnitee&quot;) from and against any and all Losses incurred by Customer
                  resulting from any Proceeding by a third party (other than an Affiliate of a Customer Indemnitee) that
                  Customer&apos;s or an Authorized User&apos;s use of the Services (excluding Customer Data and
                  Third-Party Materials) in accordance with this Agreement (including the Specifications) infringes or
                  misappropriates such third party&apos;s United States Intellectual Property Rights/United States
                  patents, copyrights, or trade secrets.
                </p>
              </Topic>
            </Menu>
            <Menu title="Customer Indemnification">
              <Topic>
                <p>
                  Customer shall indemnify, defend, and hold harmless Provider and its Affiliates, and each of its and
                  their respective officers, directors, employees, agents, successors, and assigns (each, a
                  &quot;Provider Indemnitee&quot;) from and against any and all Losses incurred by such Provider
                  Indemnitee resulting from any Proceeding by a third party (other than an Affiliate of a Provider
                  Indemnitee) that arise out of or result from, or are alleged to arise out of or result from:
                </p>
                <DashList items={customerIndemnificationItems} />
              </Topic>
            </Menu>
            <Menu title="Indemnification Procedure">
              <Topic>
                <p>
                  Each party shall promptly notify the other party in writing of any Proceeding for which such party
                  believes it is entitled to be indemnified pursuant to Section 10.1 or Section 10.2, as the case may
                  be.
                </p>
                <p>
                  The party seeking indemnification (the &quot;Indemnitee&quot;) shall cooperate with the other party
                  (the &quot;Indemnitor&quot;) at the Indemnitor&apos;s sole cost and expense. The Indemnitor shall
                  promptly assume control of the defense and shall employ counsel reasonably acceptable to the
                  Indemnitee to handle and defend the same, at the Indemnitor&apos;s sole cost and expense.
                </p>
                <p>
                  The Indemnitee may participate in and observe the proceedings at its own cost and expense with counsel
                  of its own choosing. The Indemnitor shall not settle any Proceeding without the Indemnitee&apos;s
                  prior written consent, which shall not be unreasonably withheld or delayed.
                </p>
                <p>
                  If the Indemnitor fails or refuses to assume control of the defense of such Proceeding, the Indemnitee
                  shall have the right, but no obligation, to defend against such Proceeding, including settling such
                  Proceeding after giving notice to the Indemnitor, in each case in such manner and on such terms as the
                  Indemnitee may deem appropriate.
                </p>
                <p>
                  The Indemnitee&apos;s failure to perform any obligations under this Section 10.3 will not relieve the
                  Indemnitor of its obligations under this Section 10, except to the extent that the Indemnitor can
                  demonstrate that it has been materially prejudiced as a result of such failure.
                </p>
              </Topic>
            </Menu>
          </Section>

          <Section title="Limitations of Liability; Disclaimer of Warranties">
            <Menu title="Disclaimer of Warranties">
              <Topic>
                <p>
                  <span className="head">
                    EXCEPT FOR THE EXPRESS WARRANTIES SET FORTH IN THIS AGREEMENT ALL SERVICES AND PROVIDER MATERIALS
                    ARE PROVIDED &quot;AS IS&quot; AND PROVIDER DISCLAIMS ALL OTHER EXPRESS OR IMPLIED WARRANTIES.
                  </span>
                </p>
                <p>
                  <span className="head">
                    PROVIDER SPECIFICALLY DISCLAIMS ALL IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
                    PURPOSE, TITLE, AND NON-INFRINGEMENT, AND ALL WARRANTIES ARISING FROM COURSE OF DEALING, USAGE, OR
                    TRADE PRACTICE.
                  </span>
                </p>
                <p>
                  <span className="head">
                    WITHOUT LIMITING THE FOREGOING AND EXCEPT AS SET FORTH IN THIS AGREEMENT, PROVIDER MAKES NO WARRANTY
                    OF ANY KIND THAT THE SERVICES OR PROVIDER MATERIALS, OR ANY PRODUCTS OR RESULTS OF THE USE THEREOF,
                    WILL MEET CUSTOMER&apos;S OR ANY OTHER PERSON&apos;S REQUIREMENTS, OPERATE WITHOUT INTERRUPTION,
                    ACHIEVE ANY INTENDED RESULT, BE COMPATIBLE OR WORK WITH ANY SOFTWARE, SYSTEM, OR OTHER SERVICES, OR
                    BE SECURE, ACCURATE, COMPLETE, FREE OF HARMFUL CODE, OR ERROR FREE.
                  </span>
                </p>
                <p>
                  <span className="head">
                    ALL THIRD-PARTY MATERIALS ARE PROVIDED &quot;AS IS&quot; AND ANY REPRESENTATION OR WARRANTY OF OR
                    CONCERNING ANY THIRD-PARTY MATERIALS IS STRICTLY BETWEEN CUSTOMER AND THE THIRD-PARTY OWNER.
                  </span>
                </p>
              </Topic>
            </Menu>
            <Menu title="No Consequential or Indirect Damages">
              <Topic>
                <p>
                  <span className="head">
                    IN NO EVENT SHALL PROVIDER OR ANY OF ITS REPRESENTATIVES OR AFFILIATES BE LIABLE FOR CONSEQUENTIAL,
                    INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, PUNITIVE OR ENHANCED DAMAGES LOST PROFITS OR REVENUES, OR
                    DIMINUTION IN VALUE, ARISING OUT OF, RELATING TO, OR IN CONNECTION WITH ANY BREACH OF THIS
                    AGREEMENT, REGARDLESS OF (A) WHETHER SUCH DAMAGES WERE FORESEEABLE, (B) WHETHER OR NOT IT WAS
                    ADVISED OF THE POSSIBILITY OF SUCH DAMAGES AND (C) THE LEGAL OR EQUITABLE THEORY (CONTRACT, TORT, OR
                    OTHERWISE) UPON WHICH THE CLAIM IS BASED.
                  </span>
                </p>
              </Topic>
            </Menu>
            <Menu title="Exclusion of Damages">
              <Topic>
                <p>
                  <span className="head">
                    IN NO EVENT WILL PROVIDER OR ANY OF ITS AFFILIATES BE LIABLE UNDER OR IN CONNECTION WITH THIS
                    AGREEMENT OR ITS SUBJECT MATTER UNDER ANY LEGAL OR EQUITABLE THEORY, INCLUDING BREACH OF CONTRACT,
                    TORT (INCLUDING NEGLIGENCE), STRICT LIABILITY, AND OTHERWISE, FOR ANY:
                  </span>
                </p>
                <DashList items={exclusionOfDamagesItems} />
              </Topic>
            </Menu>
            <Menu title="Cap on Monetary Liability">
              <Topic>
                <p>
                  <span className="head">
                    IN NO EVENT WILL THE AGGREGATE LIABILITY OF PROVIDER AND ITS AFFILIATES ARISING OUT OF OR RELATED TO
                    THIS AGREEMENT, WHETHER ARISING UNDER OR RELATED TO BREACH OF CONTRACT, TORT (INCLUDING NEGLIGENCE),
                    STRICT LIABILITY, OR ANY OTHER LEGAL OR EQUITABLE THEORY, EXCEED ONE AND ONE-THIRD (1 1/3) TIMES THE
                    TOTAL AMOUNTS PAID TO PROVIDER UNDER THIS AGREEMENT IN THE ONE (1) YEAR PERIOD PRECEDING THE EVENT
                    GIVING RISE TO THE CLAIM. THE FOREGOING LIMITATIONS APPLY EVEN IF ANY REMEDY FAILS OF ITS ESSENTIAL
                    PURPOSE.
                  </span>
                </p>
              </Topic>
            </Menu>
            <Menu title="Sole Remedy">
              <Topic>
                <p>
                  <span className="head">
                    SECTION 4.2, SECTION 10, AND THIS SECTION 11 SET FORTH CUSTOMER&apos;S SOLE REMEDIES AND
                    PROVIDER&apos;S SOLE LIABILITY AND OBLIGATION FOR ANY ACTUAL, THREATENED, OR ALLEGED CLAIMS UNDER OR
                    RELATED TO THIS AGREEMENT.
                  </span>
                </p>
                <p>
                  <span className="head">
                    THE TERMS AND CONDITIONS OF THIS SECTION 11 ARE AN INTEGRAL PART OF THE CONSIDERATION FOR THIS
                    AGREEMENT AND FORM A MATERIAL BASIS FOR THE AMOUNT OF THE FEES CHARGED FOR THE SERVICES.
                  </span>
                </p>
                <p>
                  <span className="head">
                    THE PROVIDER WOULD NOT ENTER INTO THIS AGREEMENT, AND WOULD NOT CONSIDER THE FEES AS ACCEPTABLE
                    COMPENSATION FOR THE SERVICES, ABSENT THE TERMS AND CONDITIONS OF THIS SECTION 11.
                  </span>
                </p>
                <p>
                  <span className="head">
                    THIS AGREEMENT IS NOT INTENDED TO CONSITUTE, AND DOES NOT CONSTITUTE, ANY FORM OF INSURANCE AGAINST
                    DAMAGE RESULTING FROM HARMFUL CODE, BREACH OF OR DAMAGE TO CUSTOMER DATA OR CUSTOMER SYSTEMS, OR
                    OTHER LOSS.
                  </span>
                </p>
                <p>
                  <span className="head">
                    CUSTOMER IS STRONGLY ENCOURAGED TO OBTAIN INSURANCE AGAINST THE RISK AND LOSSES ADDRESSED IN THIS
                    SECTION 11, IF APPLICABLE, AND TO SELF-INSURE TO THE EXTENT NECESSARY.
                  </span>
                </p>
              </Topic>
            </Menu>
          </Section>

          <Section title="Term and Termination">
            <Menu title="Initial Term">
              <Topic>
                <p>
                  The initial term of this Agreement shall commence upon the Effective Date and continue as set forth on
                  Exhibit A (the &quot;Initial Term&quot;).
                </p>
              </Topic>
            </Menu>
            <Menu title="Renewal Term">
              <Topic>
                <p>
                  Upon expiration of the Initial Term, Customer&apos;s right to use the Provider Platform shall
                  automatically renew for two single one (1) year terms (each a &quot;Renewal Term&quot; and with the
                  Initial Term, the &quot;Term&quot;), unless either party notifies the other of its intent to cancel at
                  least thirty (30) days prior to the end of the Initial Term or a Renewal Term.
                </p>
              </Topic>
            </Menu>
            <Menu title="Termination">
              <Topic>
                <p>In addition to any other express termination right set forth elsewhere in this Agreement:</p>
                <DashList items={terminationItems} />
              </Topic>
            </Menu>
            <Menu title="Effect of Termination or Expiration">
              <Topic>
                <p>
                  Upon any expiration or termination of this Agreement, except as expressly otherwise provided in this
                  Agreement including Section 12.5:
                </p>
                <DashList items={effectOfTerminationItems} />
              </Topic>
            </Menu>
            <Menu title="Surviving Terms">
              <Topic>
                <p>
                  The provisions set forth in the following sections, and any other right or obligation of the parties
                  in this Agreement that, by its nature, should survive termination or expiration of this Agreement,
                  will survive any expiration or termination of this Agreement: Sections 2.1, 6, 7, 9, 11, 12.4, this
                  12.5, and 13.
                </p>
              </Topic>
            </Menu>
          </Section>

          <Section title="Miscellaneous">
            <Menu title="Further Assurances">
              <Topic>
                <p>
                  On a party&apos;s reasonable request, the other party shall, at the requesting party&apos;s sole cost
                  and expense, execute and deliver all such documents and instruments, and take all such further
                  actions, as may be necessary to give full effect to this Agreement.
                </p>
              </Topic>
            </Menu>
            <Menu title="Relationship of the Parties">
              <Topic>
                <p>
                  The relationship between the parties is that of independent contractors. Nothing contained in this
                  Agreement shall be construed as creating any agency, partnership, joint venture, or other form of
                  joint enterprise, employment, or fiduciary relationship between the parties, and neither party shall
                  have authority to contract for or bind the other party in any manner whatsoever.
                </p>
              </Topic>
            </Menu>
            <Menu title="Public Announcements">
              <Topic>
                <p>
                  Neither party shall issue or release any announcement, statement, press release, or other publicity or
                  marketing materials relating to this Agreement or, unless expressly permitted under this Agreement,
                  otherwise use the other party&apos;s trademarks, service marks, trade names, logos, domain names, or
                  other indicia of source, association, or sponsorship, in each case, without the prior written consent
                  of the other party, which consent shall not be unreasonably withheld, provided, however, that Provider
                  may, without Customer&apos;s consent, include Customer&apos;s name and other indicia in its lists of
                  Provider&apos;s current or former customers of Provider in promotional and marketing materials.
                </p>
                <p>
                  Notwithstanding the foregoing, Provider may use Customer&apos;s name and use of Services for marketing
                  purposes, provided that Provider obtains written consent from Customer regarding the scope of such
                  publication.
                </p>
              </Topic>
            </Menu>
            <Menu title="Notices">
              <Topic>
                <p>
                  Except as otherwise expressly set forth in this Agreement, any notice, request, consent, claim,
                  demand, waiver, or other communications under this Agreement have legal effect only if in writing and
                  addressed to a party at the address specified on Exhibit A (or to such other address or such other
                  person that such party may designate from time to time in accordance with this Section 13.4).
                </p>
                <p>
                  Notices sent in accordance with this Section 13.4 will be deemed effectively given: (a) when received,
                  if delivered by hand; (b) when received, if sent by a nationally recognized overnight courier; (c) on
                  the fifth (5th) day after the date mailed by certified or registered mail, return receipt requested,
                  postage prepaid and (d) by email when, and only if, the receiving party sends a non-automated response
                  email.
                </p>
              </Topic>
            </Menu>
            <Menu title="Interpretation">
              <Topic>
                <p>For purposes of this Agreement:</p>
                <DashList items={interpretationItems} />
                <p>Unless the context otherwise requires, references in this Agreement:</p>
                <DashList items={referenceItems} />
                <p>
                  The parties intend this Agreement to be construed without regard to any presumption or rule requiring
                  construction or interpretation against the party drafting an instrument or causing any instrument to
                  be drafted.
                </p>
                <p>
                  The exhibits, schedules, attachments, and appendices referred to herein are an integral part of this
                  Agreement to the same extent as if they were set forth verbatim herein.
                </p>
              </Topic>
            </Menu>
            <Menu title="Headings">
              <Topic>
                <p>
                  The headings in this Agreement are for reference only and do not affect the interpretation of this
                  Agreement.
                </p>
              </Topic>
            </Menu>
            <Menu title="Entire Agreement">
              <Topic>
                <p>
                  This Agreement constitutes the sole and entire agreement of the parties with respect to the subject
                  matter of this agreement and supersedes all prior and contemporaneous understandings, agreements,
                  representations, and warranties, both written and oral, with respect to such subject matter.
                </p>
              </Topic>
            </Menu>
            <Menu title="Assignment">
              <Topic>
                <p>
                  Neither party shall not assign or otherwise transfer any of its rights, or delegate or otherwise
                  transfer any of its obligations or performance under this Agreement, in each case whether voluntarily,
                  involuntarily, by operation of law, or otherwise, except as explicitly permitted in this Agreement.
                </p>
                <p>
                  A party may assign this Agreement in connection with the sale of, or transfer of, substantially all of
                  its assets, provided that such party shall remain liable and responsible for all obligations under
                  this Agreement.
                </p>
                <p>
                  This Agreement is binding upon and inures to the benefit of the parties hereto and their respective
                  successors and permitted assigns.
                </p>
              </Topic>
            </Menu>
            <Menu title="Force Majeure">
              <Topic>
                <p>
                  In no event will either party be liable or responsible to the other party, or be deemed to have
                  defaulted under or breached this Agreement, for any failure or delay in fulfilling or performing any
                  term of this Agreement (except for any obligations to make payments), when and to the extent such
                  failure or delay is caused by any circumstances beyond such party&apos;s reasonable control (a
                  &quot;Force Majeure Event&quot;) due to:
                </p>
                <DashList items={forceMajeureItems} />
                <p>
                  Either party may terminate this Agreement if a Force Majeure Event affecting the other party continues
                  substantially uninterrupted for a period of sixty (60) days or more.
                </p>
                <p>
                  In the event of any failure or delay caused by a Force Majeure Event, the affected party shall give
                  prompt written notice to the other party stating the period of time the occurrence is expected to
                  continue and use commercially reasonable efforts to end the failure or delay and minimize the effects
                  of such Force Majeure Event.
                </p>
              </Topic>
            </Menu>
            <Menu title="No Third-Party Beneficiaries">
              <Topic>
                <p>
                  This Agreement is for the sole benefit of the parties hereto and their respective successors and
                  permitted assigns and nothing herein, express or implied, is intended to or shall confer upon any
                  other Person any legal or equitable right, benefit, or remedy of any nature whatsoever under or by
                  reason of this Agreement.
                </p>
              </Topic>
            </Menu>
            <Menu title="Amendment and Modification; Waiver">
              <Topic>
                <p>
                  No amendment to or modification of this Agreement is effective unless it is in writing and signed by
                  an authorized representative of each party; provided, however, that Provider may amend these Terms and
                  Conditions on a prospective basis effective (i) following the end of the then current Term, or (ii)
                  thirty (30) days following notice (which may be delivered via messaging in Provider&apos;s online
                  portal for Customer) to Customer of the amended Terms and Conditions in which case Customer may
                  terminate this Agreement by providing written notice to Provider prior to the end of such thirty (30)
                  day period.
                </p>
                <p>
                  No waiver by any party of any of the provisions hereof shall be effective unless explicitly set forth
                  in writing and signed by the party so waiving. Except as otherwise set forth in this Agreement, no
                  failure to exercise, or delay in exercising, any rights, remedy, power, or privilege arising from this
                  Agreement will operate or be construed as a waiver thereof; nor shall any single or partial exercise
                  of any right, remedy, power, or privilege hereunder preclude any other or further exercise thereof or
                  the exercise of any other right, remedy, power, or privilege.
                </p>
              </Topic>
            </Menu>
            <Menu title="Severability">
              <Topic>
                <p>
                  If any term or provision of this Agreement is invalid, illegal, or unenforceable in any jurisdiction,
                  such invalidity, illegality, or unenforceability shall not affect any other term or provision of this
                  Agreement or invalidate or render unenforceable such term or provision in any other jurisdiction.
                </p>
                <p>
                  Upon such determination that any term or other provision is invalid, illegal, or unenforceable, the
                  parties hereto shall negotiate in good faith to modify this Agreement so as to effect the original
                  intent of the parties as closely as possible in a mutually acceptable manner in order that the
                  transactions contemplated hereby be consummated as originally contemplated to the greatest extent
                  possible.
                </p>
              </Topic>
            </Menu>
            <Menu title="Governing Law; Submission to Jurisdiction">
              <Topic>
                <p>
                  This Agreement is governed by and construed in accordance with the internal laws of the State of
                  Florida without giving effect to any choice or conflict of law provision or rule that would require or
                  permit the application of the laws of any jurisdiction other than those of the State of Florida.
                </p>
                <p>
                  Any legal suit, action, or proceeding arising out of or related to this Agreement or the licenses
                  granted hereunder will be instituted in the federal courts of the United States or the courts of the
                  State of Florida in each case having jurisdiction over the city of Jacksonville, and each party
                  irrevocably submits to the exclusive jurisdiction of such courts in any such suit, action, or
                  proceeding.
                </p>
                <p>
                  Service of process, summons, notice, or other document by mail to such party&apos;s address set forth
                  on Exhibit A shall be effective service of process for any suit, action, or other proceeding brought
                  in any such court.
                </p>
              </Topic>
            </Menu>
            <Menu title="Waiver of Jury Trial">
              <Topic>
                <p>
                  Each party irrevocably and unconditionally waives any right it may have to a trial by jury in respect
                  of any legal action arising out of or relating to this Agreement or the transactions contemplated
                  hereby.
                </p>
              </Topic>
            </Menu>
            <Menu title="Attorneys' Fees">
              <Topic>
                <p>
                  In the event that any action, suit, or other legal or administrative proceeding is instituted or
                  commenced by either party against the other party arising out of or related to this Agreement, the
                  prevailing party is entitled to recover its reasonable attorneys&apos; fees and court costs from the
                  non-prevailing party.
                </p>
              </Topic>
            </Menu>
            <Menu title="Counterparts">
              <Topic>
                <p>
                  This Agreement may be executed in counterparts, each of which is deemed an original, but all of which
                  together are deemed to be one and the same agreement.
                </p>
                <p>
                  A copy of this Agreement executed and delivered by facsimile, email, or other means of electronic
                  transmission is deemed to have the same legal effect as delivery of an original signed copy of this
                  Agreement.
                </p>
              </Topic>
            </Menu>
          </Section>
        </div>
      </div>
    </div>
  );
}
